module.exports = __webpack_public_path__ + "img/cloud-warning.45ccd16c.svg";